export const capitalize = str => {
  var output = str.charAt(0).toUpperCase() + str.slice(1);
  return output;
};
export default capitalize;